import { render, staticRenderFns } from "./userFactory.vue?vue&type=template&id=bc4213a2&scoped=true&"
import script from "./userFactory.vue?vue&type=script&lang=js&"
export * from "./userFactory.vue?vue&type=script&lang=js&"
import style0 from "./userFactory.vue?vue&type=style&index=0&id=bc4213a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4213a2",
  null
  
)

export default component.exports